import { render, staticRenderFns } from "./ListItemActions.vue?vue&type=template&id=485016ee"
import script from "./ListItemActions.vue?vue&type=script&lang=ts"
export * from "./ListItemActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports